import { Component, Input } from '@angular/core';
import { untilDestroyed, UntilDestroy } from '@ngneat/until-destroy';
import { filter } from 'rxjs/operators';

import { Currency } from '../../core/model/core/currency';
import { UserStoreService } from '../../core/store/user-store.service';

@UntilDestroy()
@Component({
  selector: 'app-progress',
  templateUrl: './progress.component.html',
  styleUrls: ['./progress.component.scss'],
})
export class ProgressComponent {
  @Input() progress: number;
  @Input() min: number;
  @Input() max: number;
  currency?: Currency;

  constructor(private userStore: UserStoreService) {
    this.userStore.currency$.pipe(untilDestroyed(this), filter(Boolean)).subscribe((currency) => {
      this.currency = currency;
    });
  }
}
